import * as z from "zod";
import { ProofRunSnapshot } from "./proofRun";

/** Stamped by the backend's ProofHeroWake when a run's hero claim closes while the run is still going. */
const ProofProgressMetadata = z.object({
  child_session_id: z.string(),
  run_id: z.string(),
  kind: z.literal("hero"),
  snapshot: ProofRunSnapshot,
});
export type ProofProgressMetadata = z.infer<typeof ProofProgressMetadata>;

const parsedByRaw = new WeakMap<object, ProofProgressMetadata | null>();

export function proofProgressMetadata(message: {
  role: string;
  metadata?: Record<string, unknown> | null;
}): ProofProgressMetadata | null {
  if (message.role !== "agent") return null;
  const raw = message.metadata?.proof_progress;
  if (typeof raw !== "object" || raw === null) return null;
  let parsed = parsedByRaw.get(raw);
  if (parsed === undefined) {
    const result = ProofProgressMetadata.safeParse(raw);
    parsed = result.success ? result.data : null;
    parsedByRaw.set(raw, parsed);
  }
  return parsed;
}

/** Display-only row, not a turn of this session: working-state and turn-anchoring scans skip it. */
export function isProofProgressMessage(message: {
  role: string;
  metadata?: Record<string, unknown> | null;
}): boolean {
  return proofProgressMetadata(message) !== null;
}
